class UgFlashSaleCards extends HTMLElement {
  connectedCallback() {
    this.updateCountdowns();
    this.countdownTimer = window.setInterval(() => this.updateCountdowns(), 1000);
    this.addEventListener('click', this.handleClick);
    this.loadRemainingCollectionPages();
  }

  loadRemainingCollectionPages = async () => {
    const marker = this.querySelector('[data-fs-load-all]');
    if (!marker || marker.dataset.loaded === 'true') return;
    const pages = Number(marker.dataset.pages || 1);
    const sectionId = marker.dataset.sectionId;
    if (!sectionId || pages <= 1) return;
    marker.dataset.loaded = 'true';
    const grid = this.querySelector('.ug-flash-sale-cards__grid');
    if (!grid) return;
    const htmlPages = await Promise.all(
      Array.from({ length: pages - 1 }, (_, index) => {
        const url = new URL(window.location.href);
        url.searchParams.set('section_id', sectionId);
        url.searchParams.set('page', String(index + 2));
        return fetch(url.toString()).then((response) => response.text());
      })
    );
    htmlPages.forEach((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      doc.querySelectorAll('.ug-flash-sale-cards__grid > .ug-flash-sale-card').forEach((card) => {
        grid.appendChild(card);
      });
    });
  };

  disconnectedCallback() {
    window.clearInterval(this.countdownTimer);
    this.removeEventListener('click', this.handleClick);
  }

  handleClick = async (event) => {
    const expandButton = event.target.closest('[data-flash-sale-expand]');
    if (expandButton) {
      const deals = this.closest('.ug-flash-sale-deals');
      const twoColMobile = deals
        && deals.classList.contains('ug-flash-sale-deals--mob-two-col')
        && window.matchMedia('(max-width: 768px)').matches;
      const collapsibleCards = this.querySelectorAll(
        twoColMobile ? '.ug-flash-sale-card.is-collapsible-mb' : '.ug-flash-sale-card.is-collapsible'
      );
      const hiddenClass = twoColMobile ? 'is-hidden-mb' : 'is-hidden';
      const isExpanded = expandButton.getAttribute('aria-expanded') === 'true';
      collapsibleCards.forEach((card) => card.classList.toggle(hiddenClass, isExpanded));
      expandButton.setAttribute('aria-expanded', String(!isExpanded));
      expandButton.textContent = isExpanded
        ? expandButton.dataset.expandLabel || 'Show more >'
        : expandButton.dataset.collapseLabel || 'Show less >';
      return;
    }

    const copyButton = event.target.closest('[data-flash-sale-copy]');
    if (!copyButton) return;
    const code = copyButton.dataset.flashSaleCopy;
    if (!code) return;
    try {
      await navigator.clipboard.writeText(code);
      const label = copyButton.textContent;
      copyButton.textContent = copyButton.dataset.copiedLabel || 'Copied!';
      window.setTimeout(() => {
        copyButton.textContent = label || copyButton.dataset.copyLabel || 'Copy';
      }, 1800);
    } catch (error) {
      return;
    }
  };

  /** 与 ug-comp-countdown 一致：解析商店 `%z`（如 +0800）为小时偏移 */
  extractTimezoneHour(offset) {
    if (!offset) return 0;
    const match = String(offset).trim().match(/^([+-])(\d{2})(\d{2})$/);
    if (!match) return 0;
    const sign = match[1] === '+' ? 1 : -1;
    const hours = parseInt(match[2], 10);
    const minutes = parseInt(match[3], 10);
    return sign * (hours + minutes / 60);
  }

  /**
   * 将后台配置的结束时间按商店时区墙钟解释为绝对时间戳。
   * 与 ug-comp-countdown.parseTargetToUTC 对齐，避免 Date.parse 走访客本地时区。
   */
  parseEndTime(raw) {
    const trimmed = String(raw || '').trim();
    if (!trimmed) return NaN;
    const tzH = this.extractTimezoneHour(this.dataset.shopTimezone);
    const hasTime = trimmed.includes(':');
    let fullStr = hasTime ? trimmed.replace('T', ' ') : `${trimmed} 00:00:00`;
    fullStr = fullStr.replace(/[\s\u00a0\u3000]+/g, ' ');

    const sign = tzH >= 0 ? '+' : '-';
    const absH = String(Math.trunc(Math.abs(tzH))).padStart(2, '0');
    const minPart = Math.round((Math.abs(tzH) * 60) % 60);
    const offMin = minPart > 0 ? `:${String(minPart).padStart(2, '0')}` : ':00';
    const firstSpace = fullStr.indexOf(' ');
    const localPart =
      firstSpace === -1 ? fullStr : `${fullStr.slice(0, firstSpace)}T${fullStr.slice(firstSpace + 1)}`;
    const isoStr = `${localPart}${sign}${absH}${offMin}`;

    let ms = new Date(isoStr).getTime();
    if (!Number.isNaN(ms)) return ms;

    const m = fullStr.match(/^(\d{4})-(\d{2})-(\d{2})[T\s]+(\d{1,2}):(\d{2}):(\d{2})/);
    if (!m) return NaN;
    return Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +m[6]) - tzH * 3600 * 1000;
  }

  updateCountdowns() {
    const now = Date.now();
    this.querySelectorAll('[data-flash-sale-countdown]').forEach((countdown) => {
      const end = this.parseEndTime(countdown.dataset.flashSaleCountdown);
      const value = countdown.querySelector('[data-flash-sale-countdown-value]');
      if (!value || Number.isNaN(end)) return;
      const seconds = Math.max(0, Math.floor((end - now) / 1000));
      const days = Math.floor(seconds / 86400);
      const hours = Math.floor((seconds % 86400) / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const remainingSeconds = seconds % 60;
      const clock = [hours, minutes, remainingSeconds]
        .map((part) => String(part).padStart(2, '0'))
        .join(':');
      value.textContent = days > 0 ? `${days}d ${clock}` : clock;
    });
  }
}

if (!customElements.get('ug-flash-sale-cards')) {
  customElements.define('ug-flash-sale-cards', UgFlashSaleCards);
}
